<template>
  <div class="decline-content popup">
    <a class="close-x" @click="cancelPopup">
      <img class="close-icon" src="@/assets/images/close_icon.svg" alt="">
    </a>
    <h2 class="title">
      <span>{{ $t("CONFIRM_SHOULD_REJECT_LESSON_NAMED") }}</span>
      <span>{{'"' + collectionTitle + '"'}}</span>
    </h2>
 <div class="decline-animation">
      <img src="@/assets/images/siman-kriya-red.svg" class="icon" alt="">
    </div>
    <div  class="reason-email">
      <p class="text">
         {{ $t("ADD_REJECTION_EXPLANATION_TEXT") }}
      </p>
      <div id="toolbar_container">
        <tiny-editor
          class="input textarea"
          :text.sync="textForRejection" :fullToolbar="true" :showToolbarInline="false"
        />
      </div>
    </div>
    <div class="buttons-wrap">
      <button class="common-button cancel-button" @click="cancelPopup">
        {{ $t("CANCEL") }}
      </button>
        <button class="common-button decline-button" @click="rejectLesson">
        {{ $t("REJECT") }}
      </button>
    </div>
  </div>
</template>

<script>
import TinyEditor from '@/components/tiny-editor'
export default {
  name: 'rejected-popup',
  data () {
    return {
      textForRejection: ''
    }
  },
  components: { TinyEditor },
  props: {
    collectionTitle: {
      type: String
    }
  },
  methods: {
    cancelPopup () {
      this.$emit('close-popup')
    },
    rejectLesson () {
      this.$emit('approve-popup-function', { action: 'rejected', comment: this.textForRejection })
    }
  }
}
</script>

<style >
.textarea {
    height: 120px;
    resize: none;
    margin-bottom: 0;
    line-height: 1.1;
    font-family: "Arimo", sans-serif;
}
.input {
    border-radius: 3px;
    font-size: 16px;
    width: 100%;
    padding: 5px 15px;
    margin-top: 5px;
    font-family: "Arimo", sans-serif;
}
</style>
